<template>
  <b-row class="text-center">
    <!-- Pacotes de Investimento -->
    <b-col cols="12" md="3">
      <b-card class="stat-card shadow-sm">
        <b-card-title>
          <feather-icon icon="PackageIcon" size="24" class="mr-1"/> <!-- Ícone representando pacotes -->
          {{ $t("Pacotes") }}
        </b-card-title>
        <b-card-text class="stat-value text-primary">
          {{ general ? general.amountBots : 0 }}
        </b-card-text>
      </b-card>
    </b-col>

    <!-- Liquidez -->
    <b-col cols="12" md="3">
      <b-card class="stat-card shadow-sm">
        <b-card-title>
          <feather-icon icon="DollarSignIcon" size="24" class="mr-1"/> <!-- Ícone representando valor -->
          {{ $t("Liquidez") }}
        </b-card-title>
        <b-card-text class="stat-value text-primary">
          {{ moneyFormat(general ? general.initialValue : 0) }}
        </b-card-text>
      </b-card>
    </b-col>

    <!-- Lucro -->
    <b-col cols="12" md="3">
      <b-card class="stat-card shadow-sm">
        <b-card-title>
          <feather-icon icon="TrendingUpIcon" size="24" class="mr-1"/> <!-- Ícone representando crescimento/lucro -->
          {{ $t("Lucro") }}
        </b-card-title>
        <b-card-text class="stat-value text-primary">
          {{ moneyFormat(general ? general.totalProfit : 0) }}
        </b-card-text>
      </b-card>
    </b-col>

    <!-- Comissões -->
    <b-col cols="12" md="3">
      <b-card class="stat-card shadow-sm">
        <b-card-title>
          <feather-icon icon="GiftIcon" size="24" class="mr-1"/> <!-- Ícone de presente, representando comissões -->
          {{ $t("Comissões") }}
        </b-card-title>
        <b-card-text class="stat-value text-primary">
          {{ moneyFormat(general ? general.bonus : 0) }}
        </b-card-text>
      </b-card>
    </b-col>

    <!-- Saques -->
    <b-col cols="12" md="6">
      <b-card class="stat-card shadow-sm">
        <b-card-title>
          <feather-icon icon="ArrowDownCircleIcon" size="24" class="mr-1"/> <!-- Ícone representando saques -->
          {{ $t("Saques") }}
        </b-card-title>
        <b-card-text class="stat-value text-primary">
          {{ moneyFormat(general ? general.totalWhitdraw : 0) }}
        </b-card-text>
      </b-card>
    </b-col>

    <!-- Disponível -->
    <b-col cols="12" md="6">
      <b-card class="stat-card shadow-sm">
        <b-card-title>
          <feather-icon icon="CreditCardIcon" size="24" class="mr-1"/> <!-- Ícone representando saldo disponível -->
          {{ $t("Disponível") }}
        </b-card-title>
        <b-card-text class="stat-value text-primary">
          {{ moneyFormat(general ? general.totalProfit + general.bonus - general.totalWhitdraw : 0) }}
        </b-card-text>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { BCard, BCardTitle, BCardText, BRow, BCol } from "bootstrap-vue";
import { mapGetters } from "vuex";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue"; // Importando FeatherIcon

export default {
  components: {
    BCard,
    BCardTitle,
    BCardText,
    BRow,
    BCol,
    FeatherIcon, // Registrando o componente de ícones
  },
  props: {
    general: Object,
  },
  computed: {
    ...mapGetters(["returnUser"]),
  },
};
</script>

<style scoped>
.stat-card {
  border-radius: 10px;
  background-color: #FFFFFF; /* Cor mais clara e amigável */
  padding: 10px;
  transition: transform 0.2s ease-in-out;
}

.stat-card:hover {
  transform: translateY(-5px);
}

.stat-value {
  font-size: 1.5rem;
  font-weight: bold;
  margin-top: 10px;
}

.mr-1 {
  margin-right: 0.5rem;
}
</style>
